import { mergeDeepWith } from 'ramda';
import ETypes from '../types';
import { Action, State } from './types';

export const reducers = {
  [ETypes.SET_SNIPPETS]: (state: State, action: Action): State => {
    return {
      ...state,
      snippets: mergeDeepWith(
        (s1, s2) => s2 ?? s1,
        state?.snippets,
        action?.snippets
      ),
      newSnippetIds: []
    };
  },

  [ETypes.SET_NEW_SNIPPETS_ID]: (state: State, action: Action): State => {
    return {
      ...state,
      newSnippetIds: [...state?.newSnippetIds, action?.id || ''].filter(Boolean)
    };
  }
};
